const toDeletePayload = (entity) => ({
    id: entity.id,
    _action: entity._action,
})

const keepFullPayload = (entity, mapper) => entity._action === 'delete' ? toDeletePayload(entity) : mapper(entity)

const transformToCreatePayload = (formData) => {
    return {
        id: formData.id,
        customer_id: formData.customer_id,
        trip_id: formData.trip_id,
        sales_plan_id: formData.sales_plan_id,
        box: formData.box,
        duration: formData.duration,
        description: formData.description,
        ordered_at: formData.ordered_at,
        send_to_odoo: formData.send_to_odoo,
        files: transformCreateFiles(formData),
        sale_items: transformSaleItems(formData),
        sale_additional_items: transformToSaleAdditionalItems(formData),
    }
}
const transformToUpdatePayload = (formData) => {
    return {
        customer_id: formData.customer_id,
        trip_id: formData.trip_id,
        sales_plan_id: formData.sales_plan_id,
        box: formData.box,
        duration: formData.duration,
        description: formData.description,
        is_draft: false,
        ordered_at: formData.ordered_at,
        send_to_odoo: formData.send_to_odoo,
        files: transformUpdateFiles(formData),
        sale_items: transformSaleItems(formData),
        sale_additional_items: transformToSaleAdditionalItems(formData),
        _method: 'PUT',
    }
}
const transformCreateFiles = ({files = []} = {}) => {
    return files.map((file) => ({
        id: file.id,
        path: file.file,
        _action: file._action,
    }))
}
const transformUpdateFiles = ({files = []} = {}) => {
    return files
        .filter((file) => file._action === 'delete' || typeof file.file !== 'string')
        .map((file) => keepFullPayload(file, (item) => ({
            id: item.id,
            path: item.file,
            _action: item._action,
        })))
}
const transformSaleItems = ({sale_items = []} = {}) => {
    return sale_items.map((saleItem) => keepFullPayload(saleItem, (item) => ({
        id: item.id,
        trip_item_ids: item.trip_item_ids,
        quality: item.quality,
        quantity: item.quantity,
        unit_price: item.unit_price,
        size: item.size,
        _action: item._action,
    })))
}
const transformToSaleAdditionalItems = ({sale_paid_by_jala = [], sale_paid_by_partner = []} = {}) => {
    return [
        ...sale_paid_by_jala,
        ...sale_paid_by_partner
    ].map((item) => keepFullPayload(item, (payload) => ({
        id: payload.id,
        name: payload.name,
        paid_by: payload.paid_by,
        total: -(payload.total || 0),
        is_markup_margin_item: payload.is_markup_margin_item,
        options: payload.options,
        _action: payload._action,
    })))
}
export default {
    transformToCreatePayload,
    transformToUpdatePayload
}
